import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { Link, navigate } from 'raviger';
import { Button, Card, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import L from "leaflet";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faInfoCircle, faPlusSquare, faArrowAltCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { faPencil, faBuilding } from '@fortawesome/pro-solid-svg-icons';
import Header from '../components/Header';
import { AuthContext } from "../accounts/AccountsReducer";
import { SystemErrorContext } from '../components/SystemError';
import ActionsDropdown from '../components/ActionsDropdown';
import LoadingLink from "../components/LoadingLink";

function ShelterOverview({ organization }) {

  const { state } = useContext(AuthContext);
  const { setShowSystemError } = useContext(SystemErrorContext);
  const [isLoading, setIsLoading] = useState(true);

  const [data, setData] = useState({shelters: [],  isFetching: false,});
  //const [selectedShelter, setSelectedShelter] = useState(null);

  // Hook for initializing data.
  useEffect(() => {
    let unmounted = false;
    let source = axios.CancelToken.source();

    const fetchShelters = async () => {
      setData({shelters: [], isFetching: true});
      // Fetch Shelter data.
      await axios.get('/shelter/api/shelter/?management=true&organization=' + organization, {
        cancelToken: source.token,
      })
      .then(response => {
        if (!unmounted) {
          setData({shelters: response.data, isFetching: false});
          setIsLoading(false);
        }
      })
      .catch(error => {
        if (!unmounted) {
          setData({shelters: [], isFetching: false});
          setShowSystemError(true);
        }
      });
    };
    fetchShelters();
    // Cleanup.
    return () => {
      unmounted = true;
      source.cancel();
    };
  }, [organization]);

  return (
    <>
    <span className="mt-4 ms-auto me-auto" style={{width:"80%", maxWidth:"80%"}}>
    <Header>
      <span style={{cursor:'pointer'}} onClick={() => navigate("/" + organization + '/manage/organization')} className="me-2"><FontAwesomeIcon icon={faArrowAltCircleLeft} size="sm" inverse /></span>
      {state.organization.name} - Manage Shelters
      <OverlayTrigger
        key={"new-shelter"}
        placement="bottom"
        overlay={
          <Tooltip id={`tooltip-new-shelter`}>
            Add new shelter
          </Tooltip>
        }
      >
        <Link style={{cursor:'pointer', marginLeft:'10px'}} href={"/" + organization + '/manage/shelters/new'}>
          <FontAwesomeIcon icon={faPlusSquare} size="sm" inverse />
        </Link>
      </OverlayTrigger>
    </Header>
    <Row className="flex-nowrap" style={{paddingBottom:"10px"}}>
      <Col style={{minWidth:"150px", maxWidth:"150px", marginLeft:"0px"}}>
          Shelter Name
      </Col>
      <Col style={{minWidth:"325px", maxWidth:"325px", marginLeft:"1px"}}>
          Shelter Address
      </Col>
      <Col style={{minWidth:"85px", maxWidth:"85px"}}>
          Operational
      </Col>
      <Col style={{minWidth:"85px", maxWidth:"85px"}}>
          Training
      </Col>
      <Col style={{minWidth:"125px", maxWidth:"125px"}}>
      </Col>
    </Row>
    {data.shelters.map(shelter => (
      <Card key={shelter.id} className="rounded mb-1" style={{maxWidth:"0px"}}>
        <div className="row no-gutters flex-nowrap" style={{marginLeft:"0px"}}>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", borderTopLeftRadius:"0.25rem", borderBottomLeftRadius:"0.25rem", minWidth:"150px", maxWidth:"150px", backgroundColor:"#615e5e"}}>
            {shelter.name}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"325px", maxWidth:"325px", backgroundColor:"#615e5e"}}>
            {shelter.full_address}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"85px", maxWidth:"85px", backgroundColor:"#615e5e"}}>
            {shelter.operational ? "Yes" : "No"}
            {Object.keys(shelter.active_operational_incidents || {}).length > 0 && (
            <OverlayTrigger
              key={"active-operational-incidents"}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-active-incidents`}>
                  {Object.entries(shelter.active_operational_incidents)
                    .map(([inc_slug, incident]) => (
                    <span key={inc_slug}>
                      {incident.name} ({incident.animal_count})
                      <br />
                    </span>
                  ))}
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} className="ms-1 fa-move-up" size="sm" inverse />
              </OverlayTrigger>
            )}
          </Col>
          <Col className="border-top border-start border-bottom" style={{paddingLeft:"3px", paddingTop:"5px", marginTop: "-1px", fontSize:"13px", minWidth:"85px", maxWidth:"85px", backgroundColor:"#615e5e"}}>
            {shelter.training ? "Yes" : "No"}
            {Object.keys(shelter.active_training_incidents || {}).length > 0 && (
            <OverlayTrigger
              key={"active-training-incidents"}
              placement="top"
              overlay={
                <Tooltip id={`tooltip-active-incidents`}>
                  {Object.entries(shelter.active_training_incidents)
                    .map(([inc_slug, incident]) => (
                    <span key={inc_slug}>
                      {incident.name} ({incident.animal_count})
                      <br />
                    </span>
                  ))}
                </Tooltip>
              }
            >
              <FontAwesomeIcon icon={faInfoCircle} className="ms-1 fa-move-up" size="sm" inverse />
              </OverlayTrigger>
            )}
          </Col>
          <Col className="border" style={{paddingLeft:"3px", paddingTop:"2px", marginTop: "-1px", fontSize:"13px", minWidth:"100px", maxWidth:"100px", borderTopRightRadius:"0.25rem", borderBottomRightRadius:"0.25rem", backgroundColor:"#615e5e"}}>
            <ActionsDropdown variant="secondary" title="Actions" style={{height:"26px", paddingTop:"0px"}}>
              <LoadingLink
                href={"/" + organization + "/manage/shelters/edit/" + shelter.id}
                isLoading={isLoading}
                className="d-block"
                label="Update Shelter"
              >
                <FontAwesomeIcon icon={faPencil} className="fas" inverse />
              </LoadingLink>
              <LoadingLink
                href={"/" + organization + "/manage/shelters/" + shelter.id}
                isLoading={isLoading}
                className="d-block"
                label="Manage Buildings"
              >
                <FontAwesomeIcon icon={faBuilding} className="fas" inverse />
              </LoadingLink>
            </ActionsDropdown>
          </Col>
        </div>
      </Card>
    ))}
    </span>
    </>
  )
}

export default ShelterOverview
